const state = {
  signInState: {
    email: "",
    exp: Date.now(),
    sub: "",
    region: null,
    name: null,
    ppd: null,
    roles: [],
    token: null,
  },
};

export default state;
